export default __webpack_public_path__ + "static/tub_w.23bf2c5a2093e0cae06ef3985c2e5b03.png";